import {
  format,
  parse,
  parseISO,
  differenceInCalendarDays,
  isValid,
  isToday,
  isTomorrow,
  isYesterday,
} from 'date-fns'

const toDate = (value) => (typeof value === 'string' ? parseISO(value) : value)

// Replicates moment's calendar() relative-day buckets for a timestamp: today/
// tomorrow/yesterday and the surrounding week render with the time, anything
// further out uses the caller-supplied (date-fns) sameElse format.
export const calendarTimestamp = (value, sameElseFormat) => {
  if (!value) return ''
  const date = parseISO(value)
  if (!isValid(date)) return ''
  const diff = differenceInCalendarDays(date, new Date())

  if (isToday(date)) return `Today at ${format(date, 'p')}`
  if (isTomorrow(date)) return `Tomorrow at ${format(date, 'p')}`
  if (isYesterday(date)) return `Yesterday at ${format(date, 'p')}`
  if (diff > 1 && diff < 7) return format(date, "EEEE 'at' p")
  if (diff < -1 && diff > -7) return `Last ${format(date, "EEEE 'at' p")}`
  return format(date, sameElseFormat)
}

export const isoDateString = (value) => format(toDate(value), 'yyyy-MM-dd')

export const numberOfDaysUntil = (date) =>
  Math.max(0, differenceInCalendarDays(toDate(date), new Date()))

export const shortTimeString = (value) => {
  if (!value) return ''
  const time = parse(value, 'HH:mm', new Date())
  if (!isValid(time)) return ''
  return format(time, time.getMinutes() === 0 ? 'ha' : 'h:mma').toLowerCase()
}

export const shortTimeRangeString = (start, end) =>
  `${shortTimeString(start)} – ${shortTimeString(end)}`
